import { Component, OnInit } from '@angular/core';
import { NodeBuilder } from '../../../../../../../shared/models';
import { Form, FormArray, FormGroup } from '@angular/forms';
import { nestedEndNode } from './nestedEndNode';
import { swalMini } from '../../../../../../../shared/utils/utils';

const NODE_TYPE = 'nestedEndNode';
const topAddButtonActivation = 2;

@Component({
  selector: 'app-nested-end-node',
  templateUrl: './nested-end-node.component.html',
  styleUrls: ['./nested-end-node.component.scss']
})
export class NestedEndNodeComponent extends NodeBuilder implements OnInit {

  nestedEndNodeForm: FormGroup;
  logicForm: FormGroup;

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
  }

  set buildForm(stepData: any) {
    const nestedEndNodeForms = nestedEndNode.toForm(stepData, this.canEdit);
    this.nestedEndNodeForm = nestedEndNodeForms.NestedEndNodeForm;
    this.logicForm = nestedEndNodeForms.LogicForm;

    const outputVars = this.logicForm.get('outputVars') as FormArray;
  }

  get getStepData(): {} {
    const formData = this.nestedEndNodeForm.getRawValue();
    const logicData = this.logicForm?.getRawValue();

    const nodeData = new nestedEndNode().nodeData;
    nodeData['integration']['name'] = formData.name;
    nodeData['integration']['description'] = formData.description;

    const outputVars = {};

    logicData.outputVars.forEach(outputVarGroup => {
      outputVars[outputVarGroup.key] = outputVarGroup.value;
    });

    nodeData['integration']['endNode']['outputVars'] = outputVars;

    return nodeData;
  }

  get isNodeValid(): boolean {
    this.nestedEndNodeForm.markAllAsTouched();
    this.logicForm.markAllAsTouched();
    return this.nestedEndNodeForm.valid && this.logicForm.valid;
  }

  public addVariable(): void {
    const outputVars: FormArray = this.logicForm.get('outputVars') as FormArray;

    const newOutputVarsGroup = nestedEndNode.buildOutputVarGroup('', '', this.canEdit.canEditFlows);

    outputVars.push(newOutputVarsGroup);
  }

  public deleteVariable(controlName: string, index: number): void {
    const outputVarsArray: FormArray = this.logicForm.get(controlName) as FormArray;

    if (outputVarsArray.length > 1) {
      outputVarsArray.removeAt(index);
    } else {
      swalMini({
        title: 'At least one option needed',
        type: 'error',
      });
    }
  }

  protected readonly topAddButtonActivation = topAddButtonActivation;
}
